/* src/app/core/modules/shared/components/bullet-list/bullet-list.component.scss */
/*# sourceMappingURL=/avvera/dev/bullet-list.component.css.map */
